export default "__VITE_ASSET__tWgvaWjY__"